/* THIS FILE IS AUTOGENERATED: DO NOT MAKE MODIFICATIONS */

export default ["en","nl","de","fr","es"]